module.exports = __webpack_public_path__ + "img/logo-a.8409afa4.png";